<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            文章列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入文章标题" v-model="title" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="title" label="标题"></el-table-column>

                        <el-table-column prop="description" label="简介"></el-table-column>

                        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-bind:InfoTitleList="InfoTitleList" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:InfoTitleList="InfoTitleList" v-on:closeEdit="showModalEdit=false" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledEdit:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                title:'',
                selectInfo:'',
                InfoTitleList:[],
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InfoTitle/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.InfoTitleList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            timefilter(row,index,column){
                return timefilters(column)
            },
            handleEdit() {
                this.$refs.myEdit.init(this.selectInfo);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Info/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        title:this.title,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.disabledEdit=true
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
             rowClick(row){
                this.disabledEdit=true
                this.selectInfo=row
                this.disabledEdit=false
            }
        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
